import { types } from "./types/types";


const initialState = {
    alert: null
}

export const alert = (state = initialState, action) => {
    switch (action.type) {
        case types.setAlert:
            return {
                ...state,
                alert: action.payload
            }
        case types.removeAlert:
            return {
                ...state,
                alert: null
            }
        default:
            return state;
    }
}